import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'ctr-recommendation-option',
  imports: [MatIconModule, MatButtonModule, MatRippleModule],
  templateUrl: './recommendation-option.component.html',
  styleUrl: './recommendation-option.component.scss',
})
export class RecommendationOptionComponent {
  @Input() title: string | undefined | null;
  @Input() description: string | undefined | null;
  @Input() image: string | undefined;
  @Output() action: EventEmitter<void> = new EventEmitter<void>();
}
